import {
  enum_,
  number,
  object,
  optional,
  string,
  type InferOutput
} from 'valibot'

import { SHIPMENT_ORDER_IMPORT_JOB_STATUS_TYPE } from '@/libs/api/types'

/**
 * 配送依頼のインポート履歴の検索条件
 */
export const shipmentOrderImportJobsSearchSchema = object({
  page: optional(number()),
  /** インポートステータス */
  status: optional(enum_(SHIPMENT_ORDER_IMPORT_JOB_STATUS_TYPE)),
  /** ファイル名 */
  fileName: optional(string()),
  /** 拠点ID */
  dcId: optional(number())
})

export type ShipmentOrderImportJobsSearch = InferOutput<
  typeof shipmentOrderImportJobsSearchSchema
>
